import React from 'react'
import { Modal, ModalVisibilityProps } from 'sb-modal'

import messages from './messages'


const GiftOfferConfirmModalView: React.FunctionComponent<GiftOfferConfirmModal.ReturnType & ModalVisibilityProps> = (props) => {
  const { closeModal, onConfirm, onClose } = props

  return (
    <Modal
      className="humbleBgColor"
      iconName="love"
      title={messages.title}
      text={messages.text}
      primaryButton={{
        title: messages.buttonTitle.primary,
        onClick: onConfirm,
      }}
      ordinaryButton={{
        title: messages.buttonTitle.ordinary,
        onClick: closeModal,
      }}
      onClose={onClose}
    />
  )
}


export default GiftOfferConfirmModalView
